import { render, staticRenderFns } from "./DarkChannelGeneratorPrivacyPolicyPage.vue?vue&type=template&id=a2eb1156&scoped=true"
import script from "./DarkChannelGeneratorPrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./DarkChannelGeneratorPrivacyPolicyPage.vue?vue&type=script&lang=js"
import style0 from "./DarkChannelGeneratorPrivacyPolicyPage.vue?vue&type=style&index=0&id=a2eb1156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb1156",
  null
  
)

export default component.exports